import { ILanguage, LANGUAGES_SCHEMA } from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { IGetGateway, ISaveGateway } from '../gateways';

export class LanguageGateway
  implements
    IGetGateway<null, IApiResponse<ILanguage[]>>,
    ISaveGateway<ILanguage[], IApiResponse<ILanguage[]>>
{
  private readonly restCallBuilder: RestCallBuilder<ILanguage[]> =
    new RestCallBuilder<ILanguage[]>([]);

  get(): Observable<IApiResponse<ILanguage[]>> {
    return this.restCallBuilder
      .get('/languages/')
      .validate(API_RESPONSE_SCHEMA(LANGUAGES_SCHEMA), 'Language.get')
      .handleMessages()
      .build();
  }

  save(query: ILanguage[]): Observable<IApiResponse<ILanguage[]>> {
    return this.restCallBuilder
      .post('/languages/', query)
      .validate(API_RESPONSE_SCHEMA(LANGUAGES_SCHEMA), 'Language.save')
      .handleMessages()
      .build();
  }

  delete(languageId: string): Observable<IApiResponse<any>> {
    return this.restCallBuilder
      .delete(`/languages/${languageId}`)
      .handleMessages()
      .build();
  }
}
